"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMultipart = exports.parseFailedRequest = exports.getRequestId = exports.buildRequest = void 0;
var axios_1 = __importDefault(require("axios"));
var utils_1 = require("../../utils");
var constants_1 = require("./constants");
function buildRequest(methodId, args, instanceConfig) {
    var reqConfig = constants_1.methodsWithData.includes(methodId) ? args === null || args === void 0 ? void 0 : args[2] : args === null || args === void 0 ? void 0 : args[1];
    reqConfig = __assign(__assign({}, instanceConfig), reqConfig);
    var controller = new AbortController();
    reqConfig.signal = controller.signal;
    var request = __assign({ url: args === null || args === void 0 ? void 0 : args[0] }, reqConfig);
    if (constants_1.methodsWithData.includes(methodId)) {
        request.data = args[1];
    }
    var axiosArgs = [request.url, request.data || reqConfig, reqConfig];
    return { request: request, controller: controller, axiosArgs: axiosArgs };
}
exports.buildRequest = buildRequest;
function getRequestId(req, config) {
    return "".concat(req.baseURL || (config === null || config === void 0 ? void 0 : config.baseURL) || '').concat(req.url);
}
exports.getRequestId = getRequestId;
function parseFailedRequest(err, request, instanceConfig) {
    var errorReason = null;
    var shouldReject = true;
    if (err instanceof axios_1.default.Cancel) {
        errorReason = 'REQUEST_ABORTED';
        shouldReject = instanceConfig.rejectOnCancel;
    }
    else if (err.response) {
        errorReason = 'INVALID_STATUS_CODE';
    }
    else if (err.request) {
        errorReason = 'NO_RESPONSE';
    }
    else {
        errorReason = 'SETUP_ERROR';
    }
    var failedRequest = __assign(__assign({}, request), { requestStatus: 'failed', errorReason: errorReason });
    return {
        failedRequest: failedRequest,
        shouldReject: shouldReject,
    };
}
exports.parseFailedRequest = parseFailedRequest;
var multipartDefaults = {
    keyTransforms: {
        data: 'json',
        image: 'image',
        file: 'image',
        files: 'image',
    },
};
function toMultipart(request) {
    var e_1, _a;
    var options = typeof request.multipart === 'boolean' ? {} : request.multipart;
    var multipartConfig = __assign(__assign({}, multipartDefaults), options);
    var form = new FormData();
    try {
        for (var _b = __values(Object.entries(request.data)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], rawValue = _d[1];
            var value = rawValue;
            switch (multipartConfig.keyTransforms[key]) {
                case 'json':
                    value = JSON.stringify(__assign(__assign({}, rawValue), { type: 'application/json' }));
                    break;
                case 'image':
                    if (typeof rawValue === 'string') {
                        value = {
                            uri: rawValue,
                            name: "image_".concat(rawValue),
                            type: "image/".concat((0, utils_1.parseFilePathData)(rawValue).extension),
                        };
                    }
                    else if (rawValue instanceof File) {
                        value = rawValue;
                    }
                    else {
                        value = null;
                    }
                    break;
                default:
                    break;
            }
            form.append(key, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return form;
}
exports.toMultipart = toMultipart;
